import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createUserActivity } from 'rubriq/actions';
import { hasRespondedToSubmitSurvey, markSubmitSurveyResponded } from 'rubriq/helpers/submitSurveyResponded';
import { RUBRIQ_FEATURE_SURVEY_DELAY_MS, RUBRIQ_SUBMIT_SURVEY_ZONKA_FORM_ID, RUBRIQ_SUBMIT_SURVEY_ZONKA_NONPROD_FORM_ID } from 'rubriq/constants';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import openZonkaSurvey from './zonkaFeedbackClient';
var useSubmitSurveyTrigger = function useSubmitSurveyTrigger(feature, trigger) {
  var dispatch = useDispatch();
  var isChinaUser = useSelector(getChinaLocalization);
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    _useSelector$user = _useSelector.user,
    userIdentity = _useSelector$user.identity,
    userEmail = _useSelector$user.email,
    firstName = _useSelector$user.firstName,
    lastName = _useSelector$user.lastName;
  useEffect(function () {
    if (!trigger || hasRespondedToSubmitSurvey() || !featureEnabled('zonka_survey')) {
      return undefined;
    }
    var contactName = [firstName, lastName].filter(Boolean).join(' ');
    var variables = {
      user_identity: userIdentity,
      origin: 'aje',
      feature: feature
    };
    if (contactName) {
      variables.contact_name = contactName;
    }
    if (userEmail) {
      variables.contact_email = userEmail;
    }
    var timer = setTimeout(function () {
      dispatch(createUserActivity({
        feature: feature,
        activity: 'inapp_submit_survey_sent'
      }));
      openZonkaSurvey({
        language: isChinaUser ? 'zh_TW' : 'en_US',
        variables: variables,
        formId: RUBRIQ_SUBMIT_SURVEY_ZONKA_FORM_ID,
        nonProdFormId: RUBRIQ_SUBMIT_SURVEY_ZONKA_NONPROD_FORM_ID,
        onSurveySubmitted: markSubmitSurveyResponded
      });
    }, RUBRIQ_FEATURE_SURVEY_DELAY_MS);
    return function () {
      return clearTimeout(timer);
    };
  }, [trigger, feature, dispatch, isChinaUser, userIdentity, userEmail, firstName, lastName]);
};
export default useSubmitSurveyTrigger;